// 模板 7：金融科技与风控平台

export default {
  home: {
    banners: [
      {
        img: require('@/assets/img/banner_1.jpg'),
        path: '',
        title: '智能风控与决策引擎',
        content:
          '融合多维数据与模型能力，为金融机构提供可配置的风控策略平台。'
      },
      {
        img: require('@/assets/img/banner2.jpg'),
        path: '',
        title: '实时交易监控',
        content:
          '毫秒级风控决策能力，保障线上交易安全与合规。'
      }
    ],
    bigData: {
      img: require('@/assets/img/about_img.png'),
      title: '金融数据分析与合规审计',
      subtitle: '/ FinTech Data Platform',
      paragraphs: [
        '平台整合多种业务数据源，为贷前、贷中与贷后各环节提供可视化数据支撑。',
        '通过规则与模型结合的方式，降低坏账风险并提升审批效率。'
      ],
      buttonText: '获取金融方案'
    },
    contact: {
      title: '银行与持牌机构的技术伙伴',
      subTitle: '在合规框架下释放数据价值',
      buttonText: '联系方案顾问'
    },
    customers: [],
    advantages: []
  },
  company: {
    name: '安策金融科技有限公司',
    aboutImg: require('@/assets/img/about_img.png'),
    paragraphs: [
      '__COMPANY_NAME__专注为银行、消费金融与持牌机构提供智能风控与数据分析平台。',
      '团队成员兼具金融业务与技术背景，熟悉行业监管合规要求。'
    ]
  },
  news: [
    {
      id: 'FQ01',
      title: '助力区域银行上线线上风控系统',
      introduce:
        '项目实现了贷前多维数据准入与评分机制，显著缩短审批时间。',
      date: '02-18',
      year: '2024'
    },
    {
      id: 'FQ02',
      title: '参与金融科技安全论坛',
      introduce:
        '公司在论坛分享了关于风控模型稳定性与可解释性的实践经验。',
      date: '09-12',
      year: '2023'
    },
    {
      id: 'FQ03',
      title: '交易反欺诈模块正式发布',
      introduce:
        '支持设备指纹、多终端行为与黑名单等多种数据维度，提升欺诈识别能力。',
      date: '05-06',
      year: '2023'
    },
    {
      id: 'FQ04',
      title: '风控策略可视化配置工具上线',
      introduce:
        '让业务人员在无需编码的情况下即可配置与调整多种风控策略。',
      date: '12-20',
      year: '2022'
    },
    {
      id: 'FQ05',
      title: '通过信息安全管理体系认证',
      introduce:
        '公司顺利通过信息安全管理体系认证，为金融客户提供更加可靠的安全保障。',
      date: '07-01',
      year: '2022'
    }
  ],
  software: {
    smartTown: {
      title: '信贷风控管理平台',
      sections: [
        {
          heading: '1. 贷前准入与评分',
          content:
            '整合多维数据源进行申请人画像构建，对申请进行准入与评分决策。'
        },
        {
          heading: '2. 贷中行为监测',
          content:
            '对授信用户的交易行为进行持续监测，识别高风险行为并预警。'
        },
        {
          heading: '3. 贷后预警与催收支持',
          content:
            '结合逾期天数与还款行为特征支持分层催收策略制定。'
        },
        {
          heading: '4. 策略与模型管理',
          content:
            '策略规则与模型统一管理，支持多版本对比与回溯。'
        }
      ]
    },
    bigData: {
      title: '金融风险数据平台',
      sections: [
        {
          heading: '1. 多源风控数据接入',
          desc:
            '支持对接征信、三方数据与内部业务系统，为风控决策提供数据基础。'
        },
        {
          heading: '2. 指标看板',
          desc:
            '预置授信、逾期与坏账等多类指标，为管理层提供风险全景视图。'
        },
        {
          heading: '3. 模型效果评估',
          desc:
            '从通过率、逾期率与收益等多维度评估模型表现，指导迭代优化。'
        },
        {
          heading: '4. 合规报表',
          desc:
            '支持生成多类监管报表，降低合规成本。'
        }
      ]
    }
  },
  services: [
    {
      id: 'section-1',
      title: '风控体系规划',
      engTitle: 'Risk Framework Design',
      img: require('@/assets/img/service1.jpg')
    },
    {
      id: 'section-2',
      title: '模型建设与评估',
      engTitle: 'Modeling & Evaluation',
      img: require('@/assets/img/service2.jpg')
    },
    {
      id: 'section-3',
      title: '系统集成实施',
      engTitle: 'System Integration',
      img: require('@/assets/img/service3.jpg')
    },
    {
      id: 'section-4',
      title: '风控运营顾问',
      engTitle: 'Risk Ops Consulting',
      img: require('@/assets/img/service4.jpg')
    }
  ],
  job: {
    title: '金融风控产品经理',
    responsibilities: [
      '负责信贷与交易风控相关产品的规划与设计；',
      '与金融机构客户沟通业务需求，输出产品方案与原型；',
      '协同数据与研发团队推进产品落地。'
    ],
    requirements: [
      '具备金融机构或金融科技公司背景，熟悉风控业务流程；',
      '具备扎实的产品能力与需求分析能力；',
      '对数据敏感，具备良好的沟通表达能力。'
    ],
    buttonText: '投递简历'
  }
};





// WEBPACK FOOTER //
// ./src/config/templates-7.js